import React, { useContext, useState, useEffect } from 'react';
import AuthContext from '../context/AuthContext';
import { FaSignOutAlt, FaUserCircle, FaBell, FaBars } from 'react-icons/fa';
import notificationService from '../services/notificationService';
import { Link } from 'react-router-dom';

const Navbar = ({ toggleSidebar }) => {
  const { user, logout } = useContext(AuthContext);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [showNotifications, setShowNotifications] = useState(false);

  const fetchNotifications = async () => {
    if (user && (user.role === 'admin' || user.role === 'muhasebe')) {
      try {
        const data = await notificationService.getAll();
        setNotifications(data.notifications);
        setUnreadCount(data.unreadCount);
      } catch (error) {
        console.error('Bildirimler alınamadı');
      }
    }
  };

  useEffect(() => {
    fetchNotifications();
    // İsteğe bağlı: Belirli aralıklarla kontrol et (örn: 60 saniyede bir)
    const interval = setInterval(fetchNotifications, 60000);
    return () => clearInterval(interval);
  }, [user]);

  const handleMarkRead = async (id) => {
    try {
      await notificationService.markRead(id);
      fetchNotifications();
    } catch (error) {
      console.error(error);
    }
  };

  const handleMarkAllRead = async () => {
    try {
      await notificationService.markAllRead();
      fetchNotifications();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <nav className="navbar navbar-light bg-white shadow px-4 py-3 mb-4" style={{ borderRadius: '0 0 15px 15px' }}>
      <span className="navbar-brand mb-0 h1 text-secondary">Yönetim Paneli</span>
      <div className="d-flex align-items-center">
        <button className="btn btn-link text-secondary me-3 d-md-none p-0" onClick={toggleSidebar}>
          <FaBars size={24} />
        </button>
        
        {/* BİLDİRİM ALANI (Sadece Admin/Muhasebe) */}
        {(user?.role === 'admin' || user?.role === 'muhasebe') && (
          <div className="position-relative me-4">
            <button 
              className="btn btn-light position-relative text-secondary"
              onClick={() => setShowNotifications(!showNotifications)}
            >
              <FaBell size={20} />
              {unreadCount > 0 && (
                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                  {unreadCount}
                </span>
              )}
            </button>

            {/* Bildirim Dropdown */}
            {showNotifications && (
              <div className="position-absolute end-0 mt-2 bg-white shadow rounded border" style={{ width: '320px', zIndex: 1050, maxHeight: '400px', overflowY: 'auto' }}>
                <div className="p-2 border-bottom d-flex justify-content-between align-items-center bg-light">
                  <h6 className="mb-0 fw-bold">Bildirimler</h6>
                  {unreadCount > 0 && (
                    <button className="btn btn-link btn-sm text-decoration-none p-0" onClick={handleMarkAllRead}>
                      Tümünü Okundu Yap
                    </button>
                  )}
                </div>
                <div className="list-group list-group-flush">
                  {notifications.length > 0 ? (
                    notifications.map(notif => (
                      <div key={notif.id} className={`list-group-item list-group-item-action ${!notif.is_read ? 'bg-light fw-bold' : ''}`}>
                        <div className="d-flex justify-content-between align-items-start">
                          <small className="text-dark">{notif.message}</small>
                          {!notif.is_read && (
                            <button className="btn btn-sm text-primary p-0 ms-2" onClick={() => handleMarkRead(notif.id)} title="Okundu işaretle">
                              ●
                            </button>
                          )}
                        </div>
                        <small className="text-muted" style={{ fontSize: '0.7rem' }}>
                          {new Date(notif.created_at).toLocaleString('tr-TR')}
                        </small>
                      </div>
                    ))
                  ) : (
                    <div className="p-3 text-center text-muted">Bildirim yok.</div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        <div className="d-flex align-items-center me-4">
          <FaUserCircle size={24} className="text-primary me-2" />
          <span className="fw-bold text-dark">{user?.full_name}</span>
          <span className="badge bg-secondary ms-2">{user?.role}</span>
        </div>
        <button onClick={logout} className="btn btn-outline-danger btn-sm d-flex align-items-center px-3">
          <FaSignOutAlt className="me-2" /> Çıkış
        </button>
      </div>
    </nav>
  );
};

export default Navbar;